import { combineReducers }    from 'redux'
import theme                  from './slices/themeSlice'
import auth                   from './slices/authSlice'
import pendidikan             from "./slices/pendidikanSlice";
import fakultas               from "./slices/fakultasSlice";
import gedung                 from "./slices/gedungSlice";
import prodi                  from "./slices/prodiSlice";
import mahasiswa              from "./slices/mahasiswaSlice";
import dosen                  from "./slices/dosenSlice";
import matkul                 from "./slices/matkulSlice";
import authdikti              from "./slices/authdiktiSlice";
import periode                from "./slices/periodeSlice";
import useraccess             from "./slices/userAccessSlice";
import userroles              from "./slices/userRolesSlice";
import adminKrs               from "./slices/adminkrsSlice";
import kurikulum              from "./slices/kurikulumSlice";
import kalenderAkademik       from "./slices/kalender-akademik/kalenderAkademikSlice";
import semester               from "./slices/semesterSlice";
import mahasiswaKrs           from "./slices/mahasiswakrsSlice";
import lookup                 from "./slices/lookupSlice";
import skalaPenilaian         from "./slices/skalaPenilaianSlice";
import masterJadwal           from "./slices/masterJadwalSlice";
import authenticationServices from "./slices/authentication/authenticationServices";
import krs                    from './slices/krs';
import masterKelas            from "./slices/masterKelas";
import kuesioner              from './slices/kuesionerSlice';
import pay                    from './slices/payment/paySlice';
import payment                from './slices/payment/paymentSlice';
import paymentCicilan         from './slices/payment/paymentCicilanSlice';
import pendaftar              from './slices/pendaftarSlice';
import billingInfo            from './slices/billinginfoSlice';
import jadwalDosen            from './slices/jadwalDosenSlice';
import jadwalMahasiswa        from './slices/jadwalMahasiswaSlice';
import perwalian              from './slices/pembimbingSlice';
import bobotPenilaian         from './slices/bobotPenilaianSlice';
import masterRuang            from './slices/masterRuangSlice';
import khs                    from './slices/mahasiswa/khsSlice';
import presensi               from './slices/presensiSlice';
import sync                   from './slices/syncSlice';
import dashboard              from "./slices/dashboard/dashboardSlice";
import paymentUpload          from './slices/payment/paymentUploadSlice';
import rencanaEval            from './slices/matkul/rencanaEvalSlice';
import configPembayaran       from './slices/payment/configPembayaranSlice';
import eventAkademik          from './slices/kalender-akademik/eventAkademikSlice';
import paymentInfo            from './slices/mahasiswa/paymentInfo';
import rekening               from "./slices/rekening/rekeningSlice";
import defaultSlice           from "./slices/default/defaultSlice";
import commonConfigPembayaran from "./slices/payment/commonConfigPembayaranSlice";
import masterBeasiswa         from "./slices/mahasiswa/masterBeasiswaSlice";
import skripsi                from "./slices/skripsi/skripsiSlice";
import jabatanAkademik        from "./slices/jabatan-prodi/jabatanAkademikSlice";
import paymentDeferment       from "./slices/payment/paymentDefermentSlice";
import wisuda                 from "./slices/wisuda/wisudaSlice";
import beasiswa                 from "./slices/beasiswa/beasiswaSlice";
import penangguhanPembayaran from "./slices/upload/penangguhanPembayaranSlice";
import tahunAkhir              from "./slices/mahasiswa/tahunAkhirSlice";

const rootReducer=( asyncReducers ) => ( state , action ) => {
    const combinedReducer=combineReducers ( {
                                                theme , auth , pendidikan , fakultas , gedung , prodi , mahasiswa , // kelas,
                                                dosen , matkul , authdikti , periode , useraccess , userroles , adminKrs ,
                                                kurikulum , kalenderAkademik , semester , mahasiswaKrs , lookup , skalaPenilaian , masterJadwal ,
                                                authenticationServices , krs , masterKelas , kuesioner , pay , payment , pendaftar , billingInfo ,
                                                jadwalDosen , jadwalMahasiswa , perwalian , bobotPenilaian , masterRuang , khs , presensi , sync ,
                                                paymentCicilan , dashboard , paymentUpload , rencanaEval , configPembayaran , eventAkademik ,
                                                rekening , paymentInfo , defaultSlice , jabatanAkademik , paymentDeferment , commonConfigPembayaran ,
                                                masterBeasiswa , skripsi, wisuda,beasiswa,penangguhanPembayaran, tahunAkhir,
                                                //wisuda ,
                                                ...asyncReducers
                                            } )
    return combinedReducer ( state , action )
}

export default rootReducer
